import React from 'react';
import ReactDOM from 'react-dom/client';
// import { PDFViewer } from '@react-pdf/renderer';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@assets/tailwind.css';
import 'react-circular-progressbar/dist/styles.css';

// eslint-disable-next-line import/order
// import { GoalSheetPDF } from '@components/molecules/goal-sheet-pdf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <PDFViewer className='w-full h-screen'>
      <GoalSheetPDF />
    </PDFViewer> */}
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
